import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HotelService } from './services/hotel.service';

@Injectable()
export class AuthguardGuard implements CanActivate {

  constructor(private user:HotelService,private router: Router)
  {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (localStorage.getItem('currentUser')) {
        // logged in so return true
        //alert("logged in");
        return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    return false;

  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/authguard.guard.ts